<template>
  <b-container class="bigStat">
    <b-row>
      <b-col cols="4" class="bigNumber" align-self="streach"><b>{{slice.primary.BigNumber}}</b></b-col>
      <b-col align-self="end" class="statText">
        <prismic-rich-text :field="slice.primary.StatText"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: "SliceParagraphWithVisual",
    props: ['item', 'slice'],
    components: {},
  }
</script>

<style scoped lang="scss">
  .bigStat{
    font-size: 20pt;
    color: $secondary;

    .bigNumber{
      background-color: #e8f0f7;
      font-size: 100pt;
      max-width: fit-content;
    }
    .statText{
      :deep(b, em){
        color: $emphasis;
      }
      background-color: #e8f0f7;
    }
  }
</style>